import { GlobalState } from '../constants';
import { ModalData, Modal } from './constants';

export const currentModalDataSelector = (state: GlobalState): ModalData | undefined => state.modal.current.data;
export const currentModalSelector = (state: GlobalState): Modal => state.modal.current;
export const modalHasHistorySelector = (state: GlobalState): boolean => !!state.modal.history.length;
